export default __webpack_public_path__ + "static/k_means_visualizer-6247afa4ccb9e5b1a9f63f0b7e5dde67.gif";